import { render, staticRenderFns } from "./PartnerNoticeList.vue?vue&type=template&id=264a124e&"
import script from "./PartnerNoticeList.vue?vue&type=script&lang=ts&"
export * from "./PartnerNoticeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports